import aditar from '@/core/store/item-ata/aditamento/aditar'
import historico from '@/core/store/item-ata/aditamento/historico'

export default {
	modules: {
		aditar,
		historico,
	},
}
